import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import corporateDataService from "services/corporate";

// --- Initial State ---
const initialState = {
  items: [],
  totalCount: 0,
  getOrganizations: {
    status: "idle",
    error: null,
  },
};

// --- Async Thunks ---
export const getCorporates = createAsyncThunk(
  "contactPersonCorporates/get",
  async ({ queryParams }, thunkAPI) => {
    try {
      const res = await corporateDataService.getAll(queryParams);
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || error.message || "Unknown error"
      );
    }
  }
);

// --- Slice ---
const contactPersonCorporatesSlice = createSlice({
  name: "contactPersonCorporatesSlice",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCorporates.pending, (state) => {
        state.getOrganizations.status = "loading";
        state.getOrganizations.error = null;
      })
      .addCase(getCorporates.fulfilled, (state, action) => {
        state.getOrganizations.status = "idle";
        state.getOrganizations.error = null;
        state.items = action.payload.items;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(getCorporates.rejected, (state, action) => {
        state.getOrganizations.status = "failed";
        state.getOrganizations.error =
          action.payload || "Failed to fetch corporates";
      });
  },
});

export const { reset } = contactPersonCorporatesSlice.actions;
export default contactPersonCorporatesSlice.reducer;
